/**
 * User: daletan
 * Date: 6/23/14
 * Time: 11:08 PM
 * Copyright 1stdibs.com, Inc. 2014. All Rights Reserved.
 */

'use strict';

//global.dibs.createNamespace('dibs.modules.controller.dfpCopyController');
var $ = require('dibs-jquery-shim');
var _ = require('underscore');
var SV = require('server-vars');
var log = require('bunsen/helpers/log');
var User = require('global/models/User');
var _googletag = require('bunsen/helpers/googletag');
var findNamespaceValue = require('find-namespace-value');
var GptLoader = require('global/modules/GptLoader');
var global = window;

var gptLoader = new GptLoader();
var defaults = {
    copyJSON: {},
};

/**
 * DfpCopyController:
 * The controller will read in a JSON file where data about the add slots is contained.
 * Currently, this is contained in json/dfpCopy.json. Each dfp ad slot should contain the following info:
 *      ++OrderId           The id number of the order associated with slot. Obtained through dfp interface
 *      ++slotId            The id number of the ad slot. Can actually be anything.
 *      ++width             Width of ad slot. Numeric
 *      ++height            Height of width slot. Numeric
 *      ++parentContainer   Name of class for parent container that will hold the dfp payload
 *                              and the final payload. Controller will not create ad slots
 *                              if parent container does not exist
 *
 * The controller has the following flow:
 *      1. Initializes googletag script on page
 *      2. Ad slots are added via addDfpCopy method. This will initialize slots in dfp server as well as
 *          create markup to receive the ad slots on our page.
 *      3. Once all ad slots have been added, fire method will ask dfp server to deliver ad slots onto our page.
 *          Fire method should only be called after all ad slots have been added. It should only be called once.
 *          Ad slots will be received in an iframe which will postMessage the desired copy.
 *      4. When iframe posts its message, a listener will take message,
 *          and append it to parentContainer. Iframe will then be removed.
 */

if (findNamespaceValue('settings.houseAds', SV)) {
    defaults.copyJSON = SV.settings.houseAds;
}

function DfpCopyController(options) {
    this.options = $.extend({}, defaults, options);
    this._defaults = defaults;

    this.init();
}

_.extend(DfpCopyController.prototype, {
    init: function() {
        var self = this;
        var gt = this.options.googletag || _googletag;

        //have to wait for GPT to be loaded before more can be done
        if (gt) {
            this.initController(gt);
        } else {
            this.initGoogletag();
            $.once('gpt:loaded', function() {
                // the require('googletag') shim does not get reassigned
                // properly, so need to do this check
                if (!_googletag && _googletag !== global.googletag) {
                    _googletag = global.googletag;
                }
                self.initController(_googletag);
            });
        }
    },
    /**
     * initGoogletag - initializes gpt script if not already initialized
     */
    initGoogletag: function() {
        gptLoader.load().done(function() {
            $.publish('gpt:loaded');
        });
    },
    /**
     * initController - initializes controller private variables
     */
    initController: function(gtag) {
        this.orders = {};
        this.spentKeys = {};
        this.googletag = gtag;
        this.eventType = global.addEventListener ? 'message' : 'onmessage';
        $.publish('dfp:loaded');
    },
    /**
     * addDfpCopy
     * @param key - key corresponding to order name in JSON file
     * @param targeting
     * @returns {obj} dfpController object
     */
    addDfpCopy: function(key, targeting) {
        var order = this.options.copyJSON[key];
        var self = this;
        var googletag = this.googletag;

        if (!order || !googletag) {
            return false;
        }

        if (!!targeting) {
            order.targeting = targeting;
        }

        order.key = key;
        if ($('.' + order.parentContainer).length) {
            this.orders[key] = order;
            googletag.cmd.push(function() {
                self.createSlotDiv(order);
                self.defineSlots(order);
                self.parseTargetingObj(order);
                self.setReferrerTargeting(order);
            });
        } else {
            console.log(
                'dfpController:addDfpCopy:' +
                    'The key provided did not match any order name in the JSON file currently being used.' +
                    'Mayhaps add it to default JSON or provide another to constructor.'
            );
        }

        return this;
    },
    /**
     * creates the div that will hold the slot payload (iframe) from dfp
     * @param order
     */
    createSlotDiv: function(order) {
        var span;
        //do not create new slot div if it already exists
        if ($('#' + order.slotId).length) {
            return;
        }

        span = $('<div>')
            .attr('id', order.slotId)
            .css({
                position: 'absolute',
                visibility: 'hidden',
            });
        if (order.hideOverflow) {
            span.css({
                overflow: 'hidden',
                'max-width': '100%',
            });
        }
        $('.' + order.parentContainer).append(span);
    },
    destructSlotDiv: function(order) {
        $('#' + order.slotId).remove();
    },
    /**
     * defines the slots in gpt
     * @param order
     */
    defineSlots: function(order) {
        var unitName = '/' + order.orderId + '/' + order.key;
        var dimensions = [order.width, order.height];
        var googletag = this.googletag;
        var slot;

        try {
            if (googletag) {
                slot = googletag.defineSlot(unitName, dimensions, order.slotId);
                if (slot) {
                    order.gtId = slot.addService(googletag.pubads());
                    if (order.gtId) {
                        order.gtId.setTargeting('env', SV.settings.environment);
                        order.gtId.setTargeting('loggedin', User.loggedIn().toString());
                    }
                }
            }
        } catch (e) {
            log.remote.error(e, window.location.href);
        }
    },
    parseTargetingObj: function(order) {
        var targeting = order.targeting;
        var toReplace = '%itemStatus%';
        var delimiter = '.';
        var itemPrice = '';
        var targetKey;
        var targetValue;
        var newStr;
        var item;
        var itemStatus;

        if (!targeting) {
            return this;
        }

        for (targetKey in targeting) {
            if (targeting.hasOwnProperty(targetKey)) {
                targetValue = targeting[targetKey];
                if (targetValue.indexOf(toReplace) > -1) {
                    item = SV.data;

                    if (item.isSold) {
                        itemStatus = 'sold';
                    } else if (item.isHold) {
                        itemStatus = 'hold';
                    } else if (item.isSuspended) {
                        itemStatus = 'suspended';
                    } else {
                        itemStatus = 'available';
                        itemPrice = (item.price ? 'with-price' : 'request-price') + delimiter;
                    }

                    newStr = itemPrice + itemStatus;
                    targetValue = targetValue.replace(toReplace, newStr);
                }

                order.gtId.setTargeting(targetKey, targetValue);
            }
        }

        return this;
    },
    /**
     * Sets 'referrer' targeting on order based on window
     * @param order
     * @param referrer Optional
     */
    setReferrerTargeting: function(order, referrer) {
        var targetKey = 'referrer';
        var targetValue = referrer || document.referrer;
        if (targetValue) {
            targetValue = targetValue
                //get just the domain
                .split('/')[2]
                //then strip out subdomains
                .split('.')
                .slice(-2)
                //and put it back together
                .join('.');

            order.gtId.setTargeting(targetKey, targetValue);
        }
    },
    /**
     * once the ads come back from dfp, they will be wrapped in an iframe. This cannot do.
     * So the iframes will postMessage their text and the controller will listen for it and
     * create divs with their text outside of the iframe so that our domain can access it
     */
    addPostMessageListener: function(orders) {
        var self = this;
        var attachEvent = global.addEventListener || global.attachEvent;

        attachEvent(
            this.eventType,
            function(e) {
                var keys = self.spentKeys;
                var orderId;
                var order;
                var key;
                var sourceId;
                e = e || global.event;

                // this ensures that the postMessage is from our window
                // since postMessage can return any domain value
                // if it doesn't match 1stdibs.com, don't do anything
                if (!_.size(e.source) && e.origin !== global.location.origin) {
                    return false;
                }

                if (e.source && e.source.frameElement) {
                    sourceId = e.source.frameElement.id;
                    for (orderId in orders) {
                        if (orders.hasOwnProperty(orderId)) {
                            order = orders[orderId];
                            key = order.key;
                            // only continue if this is the response for our order and order has not been queried yet
                            if (keys[key] !== true && sourceId.indexOf(key) > -1) {
                                keys[key] = true;
                                order.message = e.data;
                                self.constructMessageMarkup(order);
                                //we don't need that div anymore
                                self.destructSlotDiv(order);
                            }
                        }
                    }
                }
            },
            false
        );
    },
    /**
     * Parses message into JSON and passes it off so that it can be plopped into DOM
     * @param order
     */
    constructMessageMarkup: function(order) {
        var jsonMessage;
        var fullUrl;

        try {
            jsonMessage = $.parseJSON(order.message);
        } catch (e) {
            return; //nothing more we can do on error
        }

        if (jsonMessage) {
            fullUrl = this.constructFullUrl(jsonMessage);
            // For local development change the fullUrl to remove the environment domain and add the local domain, for
            // example if you were on the dev environment you would need to remove `https://dev` and add `https://devbox`.
            // fullUrl = 'https://devbox' + fullUrl.substr(11);
            this.injectUrl(fullUrl, order);
        }
    },
    /**
     * Expects the message to be a JSON string with at least a url field and possibly more fields
     *      representing variables to be passed in to url as query params
     * @param {Object} jsonMessage
     * @returns {string|undefined}
     */
    constructFullUrl: function(jsonMessage) {
        var params;
        var baseUrl;
        var prop;

        if (jsonMessage === undefined || jsonMessage.url === undefined) {
            return;
        }

        params = [];
        baseUrl = jsonMessage.url;

        delete jsonMessage.url;

        for (prop in jsonMessage) {
            if (jsonMessage.hasOwnProperty(prop)) {
                params.push(prop + '=' + jsonMessage[prop]);
            }
        }

        if (params.length !== 0) {
            baseUrl += '?';
        }

        baseUrl += params.join('&');
        return encodeURI(baseUrl);
    },
    /**
     * Constructs script for fullUrl and appends it as specified by order.parentContainer property
     * @param fullUrl
     * @param order
     */
    injectUrl: function(fullUrl, order) {
        var script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = fullUrl;
        script.id = order.slotId;
        $('.' + order.parentContainer)
            .show()[0]
            .appendChild(script);
    },
    /**
     * Needs to fire after all slots have been defined
     * and addDfpCopy calls after this has fired will not do anything unless this is fired again
     */
    fire: function() {
        var googletag = this.googletag;

        this.addPostMessageListener(this.orders);

        if (googletag) {
            // Enables all gpt services that have been associated with ad slots on the page
            googletag.cmd.push(function() {
                // this doesn't play nice with ads
                // googletag.pubads().enableSingleRequest();
                googletag.enableServices();
            });

            $.each(this.orders, function(key, value) {
                googletag.cmd.push(function() {
                    googletag.display(value.slotId);
                });
            });
        }
    },
    refresh: function(key) {
        var order = this.orders[key];
        var slot;
        var googletag;
        if (_.isObject(order) && !_.isEmpty(order)) {
            slot = order.gtId;
            googletag = this.googletag;

            //clear spent keys on refresh
            delete this.spentKeys[key];

            if (slot && googletag) {
                this.createSlotDiv(order);
                googletag.cmd.push(function() {
                    googletag.enableServices();
                    googletag.pubads().refresh();
                });
            }
        }
    },
});

module.exports = DfpCopyController;



//////////////////
// WEBPACK FOOTER
// ./assets/js/global/modules/commonjs/Dfp.js
// module id = 4159
// module chunks = 63